/**
 * Question validation result.
 */
export type QuestionValidationResult = Success | Failed

/**
 * Success.
 */
export interface Success {
  type: 'Success'
}

/**
 * Failed validation.
 */
export interface Failed {
  type: 'Failed'
  messages: string[]
}

/**
 * Question validation result.
 */
export const QuestionValidationResult = {
  /**
   * All good in the hood.
   */
  ok(): QuestionValidationResult {
    return { type: 'Success' }
  },
  /**
   * Something went wrong.
   *
   * @param messages
   */
  failed(messages: string[]): QuestionValidationResult {
    return {
      messages,
      type: 'Failed',
    }
  },
}
